module.exports = __webpack_public_path__ + "img/Img21b_207370_BjFj-3-5A28-1097.28e7f27a.jpg";